// Yup
import { object, string } from 'yup';

const denylistSchema = object().shape({
  message: string().required('Campo mensagem obrigatório'),
});

export { denylistSchema };
export default denylistSchema;
